import React, { useEffect, useState } from "react";
import apiClient from "../lib/apiClient";
import isLocalDev from "../lib/isLocalDev";

export function BusyStatus() {
  const [busy, setBusy] = useState(false);
  const [status, setStatus] = useState(null);
  const [percentDone, setPercentDone] = useState(0);

  useEffect(() => {
    // poll every second
    const interval = setInterval(() => {
      // disable for now reduce http noise
      if(isLocalDev() && false) {
        return;
      }

      apiClient.get("/api/family_office/status")
        .then(({ data }) => {
          setBusy(data.is_busy);
          setStatus(data.status);
          setPercentDone(data.percent_done || 0);
        }).catch(console.error);
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  if (!status || !busy) {
    return null;
  }

  return <div className={"d-flex mx-2 align-items-center"}>
    <span className={"me-2 small text-secondary"}>{status}</span>
    <progress value={percentDone} max="100" />
  </div>
}